import {AtributoEspecime, AtributoMonitoramento, Grupo} from "./enums";
import {Entidade} from "./Entidade";
import {Column, Entity, ManyToOne, PrimaryGeneratedColumn} from "typeorm";
import {Projeto} from "./Projeto";
import {JoinColumn} from "typeorm/browser";


@Entity("metodo_amostragem")
export class MetodoAmostragem  extends Entidade{
    @Column({nullable: false})
    nome?: string
    @Column({array: true, type: "simple-array"})
    grupos!: Grupo[]
    @Column()
    obs?: string
    @Column({array: true, type: "simple-array", name: "lista_atributos"})
    listaAtributos?: AtributoMonitoramento[]
    @ManyToOne(() => Projeto, (projeto) => projeto.metodologias)
    @JoinColumn({name: "projeto_id"})
    projeto?: Projeto
    @Column()
    agencia_sigla?: string

    @Column({type: "simple-array", enum: AtributoEspecime})
    listaAtributosEspecime?: AtributoEspecime[]

    //Nao funciona pq objetos recuperados nao sao classes MetodoAmostragem
    get nomeCompleto(): string {
        return  this.nome + " (" + this.grupos.join(",") + ")"
    }
}
